module.exports = __webpack_public_path__ + "static/media/orange-employee.0c740979.svg";